import gql from 'graphql-tag';

const query = gql`
  query getIndustries {
    getIndustries {
      id
      name
      description
      logoLink
    }
  }
`;

export default query;
